import { FaIcon } from '@ifixit/ui/components/icon';
import { Flag } from './GuideHeader';
import { getIcon, getIconStyle } from './FlagSection';

export function FullWidthFlags(props: { flags: Array<Flag> }) {
   const fullWidthFlags = props.flags.filter(flag => flag.fullWidth);

   if (!fullWidthFlags.length) {
      return null;
   }

   // eslint-disable-next-line @eslint-react/no-nested-component-definitions -- TODO: grandfathered in eslint-plugin-react -> @eslint-react migration
   const FlagIcon = ({ flag }: { flag: Flag }) =>
      'image' in flag ? (
         <img src={flag.image} className="flex self-center size-[37px]" />
      ) : (
         <FaIcon
            name={getIcon(flag.icon)}
            style={getIconStyle(flag.icon)}
            className="size-[37px] text-amber-500 shrink-0"
         />
      );

   return (
      <div className="flex flex-col gap-y-4 my-4 mx-4 sm:mx-0">
         {fullWidthFlags.map((flag, index) => (
            <div
               key={index}
               className="flex flex-1 justify-center items-center bg-amber-100 text-amber-700 border-2 border-amber-300 rounded-md px-[30px] py-3.5"
            >
               <FlagIcon flag={flag} />
               <div className="flex grow-10 shrink flex-col mx-5 items-start text-left md:items-center md:text-center">
                  <div className="flex text-base font-bold">{flag.title}</div>
                  <div className="flex text-sm">{flag.text}</div>
               </div>
               <div className="max-md:hidden flex">
                  <FlagIcon flag={flag} />
               </div>
            </div>
         ))}
      </div>
   );
}
